function isAppDevelopment() {
  return (
    process.env.NODE_ENV === 'development' ||
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'development'
  )
}

export default isAppDevelopment
